/*
  UMD header generated via modularize.js at 2015-05-07T00:34:41.064Z
*/
var module; UMD(module, {
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (Backbone, $, _) {


"use strict";
var glob = this || global;


// this has a double use mode.  Some pages
// include M very early, and operate in global mode.
// they will have initalized backbone correctly.
// some pages are using webpack, which will not
if (Backbone && $ && ! Backbone.$) {
  // init backbone correctly
  Backbone.$ = $
}

var M = glob.M = glob.M || {};
var Stationery = glob.Stationery = glob.Stationery || {};

if (false) {
  // this is for tricking the dependency analyzer
  window.M = {};
  window.Stationery = {};
  var M;
  var Stationery;
  _.clone;
  Backbone.Events;
}

// breaks more cycles.  this namespace initialization stuff is such a mess
M.Addressbook = M.Addressbook || {};

M.Cu3 = M.Cu3 || {};
// this page init stuff is here to break cycles in dependency analysis
M.Cu3.PageInit = M.Cu3.PageInit || {};
M.Cu3.PageInit.FANCY_RCP_ENABLED = false;

M.SKU = M.SKU || {};
M.Scene7 = M.Scene7 || {};

M.Collection = M.Collection || {};
M.Collection.Addressbook = M.Collection.Addressbook || {};
M.Collection.Bunting = M.Collection.Bunting || {};
M.Collection.Cu3 = M.Collection.Cu3 || {};
M.Collection.Cu3.Di = M.Collection.Cu3.Di || {};
M.Collection.DesignerSignature = M.Collection.DesignerSignature || {};
M.Collection.ProductDetails = M.Collection.ProductDetails || {};

M.Controller = M.Controller || {};
M.Controller.Order = M.Controller.Order || {};

M.Model = M.Model || {};
M.Model.Addressbook = M.Model.Addressbook || {};
M.Model.Bunting = M.Model.Bunting || {};
M.Model.Cu3 = M.Model.Cu3 || {};
M.Model.Cu3.Stationery = M.Model.Cu3.Stationery || {};
M.Model.Cu3.Di = M.Model.Cu3.Di || {};
M.Model.Cu3.Di.Front = M.Model.Cu3.Di.Front || {};
M.Model.Cu3.Di.Background = M.Model.Cu3.Di.Background || {};
M.Model.Di = M.Model.Di || {};
M.Model.DesignerSignature = M.Model.DesignerSignature || {};
M.Model.InfoDialog = M.Model.InfoDialog || {};
M.Model.Minibook = M.Model.Minibook || {};
M.Model.Order = M.Model.Order || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

M.View = M.View || {};
M.View.Addressbook = M.View.Addressbook || {};
M.View.Bunting = M.View.Bunting || {};
M.View.Browse = M.View.Browse || {};
M.View.Checkout = M.View.Checkout || {};
M.View.CU3 = M.View.CU3 || {};
M.View.Calendar = M.View.Calendar || {};
M.View.Cu3 = M.View.Cu3 || {};
M.View.Cu3.Suite = M.View.Cu3.Suite || {};
M.View.Cu3.Stationery = M.View.Cu3.Stationery || {};
M.View.Cu3.Di = M.View.Cu3.Di || {};
M.View.Cu3.Di.Front = M.View.Cu3.Di.Front || {};
M.View.Cu3.Di.Background = M.View.Cu3.Di.Background || {};
M.View.DesignerSignature = M.View.DesignerSignature || {};
M.View.InfoDialog = M.View.InfoDialog || {};
M.View.Minibook = M.View.Minibook || {};
M.View.Order = M.View.Order || {};
M.View.ProductDetails = M.View.ProductDetails || {};
M.View.WeddingVirality = M.View.WeddingVirality || {};
M.View.Util = M.View.Util || {};

M.Community = M.Community || {};
M.Community.Model = M.Community.Model || {};
M.Community.View = M.Community.View || {};
M.Community.Model.Dashboard = M.Community.Model.Dashboard || {};
M.Community.View.Dashboard = M.Community.View.Dashboard || {};

M.ProductDetails = M.ProductDetails || {};

M.Template = M.Template || {};
M.Template.ImageUpload = M.Template.ImageUpload || {};
M.Template.DesignerSignature = M.Template.DesignerSignature || {};
M.Template.ProductDetail = M.Template.ProductDetail || {};
M.Template.ProductDetails = M.Template.ProductDetails || {};
M.Template.DeliveryEstimator = M.Template.DeliveryEstimator || {};


M.Utility = M.Utility || {};
M.Utility.ProductImage = M.Utility.ProductImage || {};

M.Di = M.Di || {};
M.Di.Utility = M.Di.Utility || {};

// this global has several initialization points.  putting it here breaks cycles
M.Addressbook.totalAddressThreshold=0;

return {
  'M': M,
  'Stationery': Stationery
};

});
